import { render, staticRenderFns } from "./LoadingController.vue?vue&type=template&id=10012aae&scoped=true&"
import script from "./LoadingController.vue?vue&type=script&lang=js&"
export * from "./LoadingController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10012aae",
  null
  
)

export default component.exports